
// 表单重置
export function resetForm(refName) {
    if (this.$refs[refName]) {
      this.$refs[refName].resetFields();
    }
  }

  //为空
export function emptyVal(val,defaultStr = "-") {
  if(val=='' || val == null || val == undefined){
    return defaultStr
  }else{
    return val
  }
}

//时间处理
export function emptyTime(time) {
  const date = new Date(time);
  let year = date.getFullYear();
  let month = date.getMonth() + 1;
  
  // 月份补零
  month = month < 10 ? `0${month}` : month;

  return `${year}${month}`;
}